import Router from 'vue-router';
import Vue from 'vue';

Vue.use(Router)
const vueRouter = new Router({
    mode: 'history',
    base: process.env.NODE_ENV === 'production' ? '/DataV' : '/DataV',
    routes: [{
        path: '/',
        component: () => import( /* webpackChunkName: "page" */ '@/page/index'),
        children: [{
            path: '',
            component: () => import( /* webpackChunkName: "page" */ '@/page/list'),
        },
        {
            path: 'category',
            component: () => import( /* webpackChunkName: "page" */ '@/page/list/category'),
        }, {
            path: 'db',
            component: () => import( /* webpackChunkName: "page" */ '@/page/list/db'),
        }, {
            path: 'map',
            component: () => import( /* webpackChunkName: "page" */ '@/page/list/map'),
        }, {
            path: 'document',

        }, {
            path: 'components',
            component: () => import( /* webpackChunkName: "page" */ '@/page/list/components'),
        }]
    }, {
        path: '/create',
        name: 'create',
        component: () =>
            import( /* webpackChunkName: "page" */ '@/page/create')
    }, {
        path: '/build/:id',
        name: 'build',
        component: () =>
            import( /* webpackChunkName: "page" */ '@/page/build')
    }, {
        path: '/view/:id',
        name: 'view',
        component: () =>
            import( /* webpackChunkName: "page" */ '@/page/view')
    }]
})
export default vueRouter;
